export default "__VITE_ASSET__BbnAdAQs__"